module.exports = __webpack_public_path__ + "static/media/story_th.a3c89fe6.png";